(() => {
  if (window.__zenteinBybPlacementTracking) return;
  window.__zenteinBybPlacementTracking = true;

  const refineDedicatedPage = () => {
    const isUnlistedBuilderView =
      window.location.pathname === '/products/build-your-box-snack-singles' &&
      new URLSearchParams(window.location.search).get('view') === 'build-your-own-box';
    if (!isUnlistedBuilderView) return false;
    const root = document.querySelector('[data-zentein-byb-root]');
    if (!root) return false;

    root.querySelectorAll('.hero-clarity small').forEach((label) => {
      if (label.textContent?.trim().toLowerCase() === 'keep mixing') {
        label.textContent = 'No maximum';
      }
    });
    return true;
  };

  if (!refineDedicatedPage()) {
    const observer = new MutationObserver(() => {
      if (!refineDedicatedPage()) return;
      observer.disconnect();
    });
    observer.observe(document.documentElement, {childList: true, subtree: true});
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-zentein-byb-entry]');
    if (!link) return;

    const detail = {
      event: 'byb_entry_clicked',
      source: link.dataset.zenteinBybEntry || 'unknown',
      origin_product: link.dataset.zenteinOriginProduct || undefined,
      destination: link.getAttribute('href') || undefined,
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
    window.dispatchEvent(new CustomEvent('zentein:byb_entry_clicked', {detail}));
  });
})();
